export default __webpack_public_path__ + "static/media/CholaMSGeneralInsurance.f188528a.svg";